// API Configuration
const BASE_URL = 'https://api.gkcabs.com/';

export const API_ENDPOINTS = {

  CONTACT: `${BASE_URL}v1/gkcabs/web/get-contactus`,
  ENQUIRY: `${BASE_URL}v1/gkcabs/web/enquiry/addenquiry`,
  HOME_SCREEN: `${BASE_URL}v1/gkcabs/web/get-home-screen`,
  SAFETY_DATA: `${BASE_URL}v1/gkcabs/web/getsafetydata`,
  ABOUT_US: `${BASE_URL}v1/gkcabs/web/get-about-us`,
  GALLERY: `${BASE_URL}v1/gkcabs/web/getallgallery`,
  
};

export { BASE_URL };
